import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "./components/ui/sonner";
import { setLenis } from "./lib/scroll";
import { LangProvider } from "./lib/i18n";
import { Header } from "./components/sw/Header";
import { Hero } from "./components/sw/Hero";
import { Marquee } from "./components/sw/Marquee";
import { Method } from "./components/sw/Method";
import { OrderSection } from "./components/sw/OrderSection";
import { Installation } from "./components/sw/Installation";
import { Contact } from "./components/sw/Contact";
import { Footer } from "./components/sw/Footer";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    setLenis(lenis);
    let id;
    const raf = (t) => {
      lenis.raf(t);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <LangProvider>
    <div className="sw-root">
      <div className="sw-grain" aria-hidden="true" />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Method />
        <OrderSection />
        <Installation />
        <Contact />
      </main>
      <Footer />
      <Toaster theme="dark" position="bottom-right" />
    </div>
    </LangProvider>
  );
}
